module.exports = __webpack_public_path__ + "static/media/invoice.a2e26830.svg";